import Loader from "components/Admin/Loader";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router"; // Make sure to use "react-router-dom"

const AdminLayout = lazy(() => import("../layouts/Admin")); // Correct usage of lazy
const AdminDashboard = lazy(() => import("../pages/Admin/Dashboard"));
const AdminProducts = lazy(() => import("../pages/Admin/Products"));
const AdminCategories = lazy(() => import("../pages/Admin/Categories"));
const AdminLogin = lazy(() => import("../pages/Admin/Auth/Login"));

const WebsiteLayout = lazy(() => import("../layouts/Website"));
const Home = lazy(() => import("../pages/Home"));
const CategoryProducts = lazy(() => import("../pages/Categories/Products"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const ContactUs = lazy(() => import("../pages/ContactUs"));

const Router = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader full />}>
        <Routes>
          <Route element={<WebsiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route
              path="categories/:categorySlug"
              element={<CategoryProducts />}
            />
          </Route>
          <Route path="admin/login" element={<AdminLogin />} />
          <Route path="admin" element={<AdminLayout />}>
            <Route element={<AdminDashboard />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="categories" element={<AdminCategories />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
